/** Status/enum values used across the pipeline. Mirror backend strings. */

export const ENTITY_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const STAGE1_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const STAGE2_STATUS = {
  PENDING: 'pending',
  ROUTED: 'routed',
};

export const ROUTING_DECISION = {
  BRIEFING: 'briefing',
  STORAGE1: 'storage1',
  STORAGE2: 'storage2',
  PENDING: 'pending',
};

export const POST_BRIEFING_DECISION = {
  NO_STORAGE: 'no_storage',
  STORAGE1: 'storage1',
  STORAGE2: 'storage2',
  PENDING: 'pending',
};

export const BRIEFING_STATUS = {
  PENDING: 'pending',
  DISPATCHED: 'dispatched',
  ARCHIVED: 'archived',
};

export const STORAGE1_STATUS = {
  PENDING_MERGE: 'pending_merge',
  UNBUNDLED: 'unbundled',
  IN_BUNDLE: 'in_bundle',
  DISPATCHED: 'dispatched',
};

export const BUNDLE_STATUS = {
  BUILDING: 'building',
  READY: 'ready',
  DISPATCHED: 'dispatched',
};

export const CRON_RUN_STATUS = {
  SUCCESS: 'success',
  FAILED: 'failed',
  RUNNING: 'running',
  IDLE: 'idle',
};

export const NEWSPAPER_ACTION = {
  OCR_UPLOAD: 'OCR and Upload',
  KEYWORD_SEARCH: 'keyword_search',
};

export const SOURCE = {
  TELEGRAM: 'telegram',
  EPAPER_PDF: 'epaper_pdf',
  EPAPER_CHAT: 'epaper_chat',
  WHATSAPP: 'whatsapp',
  MANUAL: 'manual',
};

export const DISPATCH_STATUS = {
  PENDING: 'pending',
  SENT: 'sent',
  FAILED: 'failed',
};

const status = {
  ENTITY_STATUS,
  STAGE1_STATUS,
  STAGE2_STATUS,
  ROUTING_DECISION,
  POST_BRIEFING_DECISION,
  BRIEFING_STATUS,
  STORAGE1_STATUS,
  BUNDLE_STATUS,
  CRON_RUN_STATUS,
  NEWSPAPER_ACTION,
  SOURCE,
  DISPATCH_STATUS,
};

export default status;
